module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAABM0lEQVR4AazUAURDQRzH8a0FVFMkICTggVASqCgAkhQgBCApTAFFRlWBJqCoIjQIAJAkRIAACAoRGdVjvb5DnL//7u7OvnzAu37o7HKusizrRiHXqhhbwB0aPaPYitFhyMrKuTmcYNR3eAKyH9zjEos4EN/mfYb7EFqKHttoAWcIrYZO2/AuYlqXQ3ks4xTn+EVMI3J4Fq4esYo1PEHrQg7vw1YV7eIObiB7R94cvoatAeUeEmhVkJj/ii9ofTe54DbYWvo/2IsNaCUev0xZVf7BG2S36DDOFPEAW2U5fAytF1RwhFe4mpbDQ4gpxTY2MaNdyh5iKrke9BShHbpetC7UEFq/z3M5jg80qmMFk9jBFT4hm/J95AexhTHlWwlmdfxNjxpVFgcQ7wXij1AfOOJSCwCYJJwKKrPiOgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/build/cog-small.png
// module id = 162
// module chunks = 35783957827783 112966903596346 114276838955818